import { labelSizes } from '../commonDisplayOptions';
import { fieldNames } from '../fields';

export const dataModel = {
    component: String(),
    id: String(),
    label: String(),
    labelSize: labelSizes,
    scale: [],
    reportingLabel: String(),
    value: String(),
    required: Boolean(),
    toScale: String(),
    fromScale: String(),
    toLabel: String(),
    fromLabel: String()
};

export const defaults = {
    component: fieldNames.linearScale,
    labelSize: labelSizes.sm.value,
    fromScale: 1,
    toScale: 5
};
